/**
 * AccountingTab/index.jsx — Muhasebe FAZ 3.6 (PLAN §11.1, bağlayıcı karar).
 *
 * Mevcut "Muhasebe" üst sekmesi içinde 4 alt sekme (shadcn `Tabs`, pill
 * stili): Özet | Borç & Tahsilat | Senetler | Belgeler.
 *
 * Ayrı route reddedildi (detail verisi tek fetch'te geliyor, bağlam kırılır),
 * accordion reddedildi (tablo+form+senet 3000px'i aşar). Sekme sayacı
 * `Muhasebe (6)` davranışı ve sticky alt aksiyon barı bu bileşenin DIŞINDA,
 * AdminStudentDetailPage.jsx'te — buraya dokunulmadı.
 *
 * `onNavigateToProfile` (Muhasebe FAZ 4, Tur 2) — AdminStudentDetailPage.jsx'in
 * üst sekme durumunu ("Kimlik" sekmesine geç) DebtLedgerSubTab.jsx'e kadar
 * taşıyan ince bir callback; TCKN eksik uyarısının "Profil sekmesine git"
 * linki için (ayrı bir route/URL parametresi YOK, mevcut `activeTab`
 * useState'i doğrudan kullanılır).
 */
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../../components/ui/tabs';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useMokaSyncOnOpen } from '@/api/mutations/moka';
import AccountingSummarySubTab from './AccountingSummarySubTab';
import DebtLedgerSubTab from './DebtLedgerSubTab';
import PromissoryNotesSubTab from './PromissoryNotesSubTab';
import AccountingDocsSubTab from './AccountingDocsSubTab';

const SUB_TABS = [
  { id: 'summary', key: 'accounting.tabs.summary' },
  { id: 'debt_ledger', key: 'accounting.tabs.debt_ledger' },
  { id: 'promissory_notes', key: 'accounting.tabs.promissory_notes' },
  { id: 'documents', key: 'accounting.tabs.documents' },
];

export default function AccountingTab({ detail, userId, onNavigateToProfile }) {
  const { t } = useLanguage();
  const enrollments = detail?.enrollments || [];

  // Faz M (2026-09-28, feature/moka-profil-link) — Muhasebe sekmesi
  // AÇILDIĞINDA (bu bileşen mount olduğunda) Moka ödeme verisini bir kez
  // sessizce eşitler; periyodik scheduler YERİNE. Bkz. hook docstring'i.
  useMokaSyncOnOpen(userId);

  return (
    <Tabs defaultValue="summary" className="w-full">
      <TabsList className="rounded-xl bg-[var(--bg-app)] border-2 border-[var(--border-light)] h-auto p-1 flex flex-wrap gap-1 mb-4 w-fit">
        {SUB_TABS.map((tab) => (
          <TabsTrigger
            key={tab.id}
            value={tab.id}
            className="rounded-lg text-xs font-bold px-3.5 py-1.5 data-[state=active]:bg-white data-[state=active]:text-[var(--brand-primary)] data-[state=active]:shadow-sm"
            data-testid={`accounting-subtab-${tab.id}`}
          >
            {t(tab.key)}
          </TabsTrigger>
        ))}
      </TabsList>

      <TabsContent value="summary" className="mt-0">
        <AccountingSummarySubTab detail={detail} />
      </TabsContent>

      <TabsContent value="debt_ledger" className="mt-0">
        <DebtLedgerSubTab
          userId={userId}
          enrollments={enrollments}
          studentName={detail?.user?.name}
          studentTcNo={detail?.user?.tc_no}
          onNavigateToProfile={onNavigateToProfile}
        />
      </TabsContent>

      <TabsContent value="promissory_notes" className="mt-0">
        <PromissoryNotesSubTab detail={detail} userId={userId} />
      </TabsContent>

      <TabsContent value="documents" className="mt-0">
        <AccountingDocsSubTab userId={userId} detail={detail} />
      </TabsContent>
    </Tabs>
  );
}
